export enum UserStateChangeReason {
    Unknown = "Unknown",
    Registration = "Registration",
    Pause = "Pause",
    ResetPause = "ResetPause",
    DetectAbuseInAbout = "DetectAbuseInAbout",
    DetectAbuseInAboutQuestion = "DetectAbuseInAboutQuestion",
    DetectAbuseInCustomIcebreaker = "DetectAbuseInCustomIcebreaker",
    BanByBlockedCountry = "BanByBlockedCountry",
    BanByComplaints = "BanByComplaints",
    BanByExpiredTemporaryUnban = "BanByExpiredTemporaryUnban",
    BanByLinkToBannedUser = "BanByLinkToBannedUser",
    BanByMultiLogin = "BanByMultiLogin",
    BanByScamPremiumTransaction = "BanByScamPremiumTransaction",
    BanBySupport = "BanBySupport",
    UnbanBySupport = "UnbanBySupport",
    TemporaryUnbanBySupport = "TemporaryUnbanBySupport",
    ForcedVerificationBySupport = "ForcedVerificationBySupport",
    ForcedVerificationByScamMessages = "ForcedVerificationByScamMessages",
    ForcedVerificationByScreenshots = "ForcedVerificationByScreenshots",
    ForcedVerificationByMatches = "ForcedVerificationByMatches",
    SuccessfulForcedVerification = "SuccessfulForcedVerification",
    SuspiciousWasReviewed = "SuspiciousWasReviewed",
    SuspiciousByScamMessages = "SuspiciousByScamMessages",
    SuspiciousByTooManyLikes = "SuspiciousByTooManyLikes",
    SuspiciousByDuplicateVerifications = "SuspiciousByDuplicateVerifications",
    AutomaticBanByDuplicateVerifications = "AutomaticBanByDuplicateVerifications",
    SuspiciousByIpAddressesReuse = "SuspiciousByIpAddressesReuse",
    SuspiciousByNickname = "SuspiciousByNickname",
    ArchivedByInactivity = "ArchivedByInactivity",
    RestoreFromArchivedByLogin = "RestoreFromArchivedByLogin",
    CreateSupportUser = "CreateSupportUser",
    BlockSupportUser = "BlockSupportUser",
    ForcedVerificationByCelebrity = "ForcedVerificationByCelebrity",
    ForcedVerificationByDifferentFace = "ForcedVerificationByDifferentFace",
    SuspiciousByQrCode = "SuspiciousByQrCode",
    DetectAbuseInPhoto = "DetectAbuseInPhoto",
    DetectAbuseInChat = "DetectAbuseInChat",
    DetectAbuseInName = "DetectAbuseInName",
    SuspiciousByComplaints = "SuspiciousByComplaints",
    WasReviewed = "WasReviewed",
    AutomaticReviewByFullProfile = "AutomaticReviewByFullProfile",
    AutomaticReviewBySensitivePhotoDeleted = "AutomaticReviewBySensitivePhotoDeleted",
    AutomaticReviewByNormalPhotoAfterNoFace = "AutomaticReviewByNormalPhotoAfterNoFace",
    ResetReview = "ResetReview",
    ResetReviewByScamMessages = "ResetReviewByScamMessages",
    ResetReviewByTooManyLikes = "ResetReviewByTooManyLikes",
    ResetReviewByNoFacePhoto = "ResetReviewByNoFacePhoto",
    ResetReviewByAbuse = "ResetReviewByAbuse",
    ResetReviewByMultipleVerifications = "ResetReviewByMultipleVerifications",
    ResetReviewByMinorDetected = "ResetReviewByMinorDetected",
    ResetReviewByDuplicateFacePhoto = "ResetReviewByDuplicateFacePhoto",
    ResetReviewByMultiLogin = "ResetReviewByMultiLogin",
    PromoteSupportToSuperAdmin = "PromoteSupportToSuperAdmin",
    DemoteSuperAdminToSupport = "DemoteSuperAdminToSupport",
    ForcedVerificationByAbuse = "ForcedVerificationByAbuse",
    SuccessfulVerification = "SuccessfulVerification",
    ForcedVerificationByDuplicateFacePhoto = "ForcedVerificationByDuplicateFacePhoto",
    SuspiciousByDuplicateFacePhoto = "SuspiciousByDuplicateFacePhoto",
    ResetVerificationByPhotoDeleted = "ResetVerificationByPhotoDeleted",
    ResetVerificationBySupport = "ResetVerificationBySupport",
    ResetReviewBySensitivePhoto = "ResetReviewBySensitivePhoto",
    ResetReviewByDifferentFace = "ResetReviewByDifferentFace",
    ResetReviewByQrCode = "ResetReviewByQrCode",
    ResetReviewByCelebrity = "ResetReviewByCelebrity",
    SuspiciousDevice = "SuspiciousDevice",
    OldAppVersion = "OldAppVersion",
    IpAddressReuseAndPhotoDuplicates = "IpAddressReuseAndPhotoDuplicates",
    IpAddressReuseAndSuspiciousTag = "IpAddressReuseAndSuspiciousTag",
    IpAddressReuseAndAdminCheckAboutOrPhoto = "IpAddressReuseAndAdminCheckAboutOrPhoto",
    BlockedCountryInRegionCode = "BlockedCountryInRegionCode",
    DuplicateHashPhoto = "DuplicateHashPhoto",
    SuspiciousOldDevice = "SuspiciousOldDevice",
    SuspiciousAppCheckDevice = "SuspiciousAppCheckDevice",
    DetectAbuseInGreeting = "DetectAbuseInGreeting",
    ShadowDelete = "ShadowDelete",
    ReadyForReview = "ReadyForReview",
    BannedByDeviceRegionCode = 'BannedByDeviceRegionCode',
    CreateTestUser = 'CreateTestUser',
    PostponeBySupport = 'PostponeBySupport',
    CreateBlackListUser = 'CreateBlackListUser',
    BannedByBlackListHash = 'BannedByBlackListHash',
    ShadowBanByAbuse = 'ShadowBanByAbuse'
}

export const UserStateChangeReasonDesc: Record<UserStateChangeReason, string> = {
    [UserStateChangeReason.Unknown]: "Неизвестная причина",
    [UserStateChangeReason.Registration]: "Регистрация",
    [UserStateChangeReason.ReadyForReview]: "Регистрация",
    [UserStateChangeReason.Pause]: "Пауза",
    [UserStateChangeReason.ResetPause]: "Снятие паузы",
    [UserStateChangeReason.DetectAbuseInAbout]: "Триггерное слово: \"О себе\"",
    [UserStateChangeReason.DetectAbuseInAboutQuestion]: "Триггерное слово: Вопрос",
    [UserStateChangeReason.DetectAbuseInCustomIcebreaker]: "Триггерное слово: Ice Breaker",
    [UserStateChangeReason.BanByBlockedCountry]: "Бан: Заблокированная страна",
    [UserStateChangeReason.BanByComplaints]: "Бан: Множественные жалобы",
    [UserStateChangeReason.BanByExpiredTemporaryUnban]: "Бан: Конец временной разблокировки",
    [UserStateChangeReason.BanByLinkToBannedUser]: "Бан: Связь устройства с заблокированным пользователем",
    [UserStateChangeReason.BanByMultiLogin]: "Бан: Связь устройства с заблокированным пользователем",
    [UserStateChangeReason.BanByScamPremiumTransaction]: "Бан: Связь Premium транзакции с заблокированным пользователем",
    [UserStateChangeReason.BanBySupport]: "Бан: Решение поддержки",
    [UserStateChangeReason.UnbanBySupport]: "Разбан: Решение поддержки",
    [UserStateChangeReason.TemporaryUnbanBySupport]: "Временная разбан: по решению поддержки",
    [UserStateChangeReason.ForcedVerificationBySupport]: "Принудительная верификация: Решение поддержки",
    [UserStateChangeReason.ForcedVerificationByScamMessages]: "Принудительная верификация: Мошеннические сообщения",
    [UserStateChangeReason.ForcedVerificationByScreenshots]: "Принудительная верификация: Многочисленные скриншоты",
    [UserStateChangeReason.ForcedVerificationByMatches]: "Принудительная верификация: Многочисленные матчи",
    [UserStateChangeReason.SuccessfulForcedVerification]: "Успешная принудительная верификация",
    [UserStateChangeReason.SuspiciousWasReviewed]: "Успешное ревью: Подозрительный профиль",
    [UserStateChangeReason.SuspiciousByScamMessages]: "Подозрение: Мошеннические сообщения",
    [UserStateChangeReason.SuspiciousByTooManyLikes]: "Подозрение: Многочисленные лайки",
    [UserStateChangeReason.SuspiciousByDuplicateVerifications]: "Подозрение: Дублирующиеся верификации",
    [UserStateChangeReason.AutomaticBanByDuplicateVerifications]: "Авто-бан: Дублирующиеся верификации",
    [UserStateChangeReason.SuspiciousByIpAddressesReuse]: "Подозрение: Повторное использования IP",
    [UserStateChangeReason.SuspiciousByNickname]: "Подозрение: Имя",
    [UserStateChangeReason.ArchivedByInactivity]: "Архивация: Неактивность",
    [UserStateChangeReason.RestoreFromArchivedByLogin]: "Восстановление из архива по входу",
    [UserStateChangeReason.CreateSupportUser]: "Регистрация: Аккаунт поддержки",
    [UserStateChangeReason.BlockSupportUser]: "Бан: Аккаунт поддержки",
    [UserStateChangeReason.ForcedVerificationByCelebrity]: "Принудительная верификация: Знаменитость на фото",
    [UserStateChangeReason.ForcedVerificationByDifferentFace]: "Принудительная верификация: Разные лица на фото",
    [UserStateChangeReason.SuspiciousByQrCode]: "Подозрение: QR-код на фото",
    [UserStateChangeReason.DetectAbuseInPhoto]: "Триггерное слово: Фото",
    [UserStateChangeReason.DetectAbuseInChat]: "Триггерное слово: Чат",
    [UserStateChangeReason.DetectAbuseInName]: "Триггерное слово: Имя",
    [UserStateChangeReason.SuspiciousByComplaints]: "Подозрение: Многочисленные жалобы",
    [UserStateChangeReason.WasReviewed]: "Ручное ревью пройдено",
    [UserStateChangeReason.AutomaticReviewByFullProfile]: "Авто-ревью",
    [UserStateChangeReason.AutomaticReviewBySensitivePhotoDeleted]: "Авто-ревью: После удаления Sensitive",
    [UserStateChangeReason.AutomaticReviewByNormalPhotoAfterNoFace]: "Авто-ревью: После добавления фото с лицом",
    [UserStateChangeReason.ResetReview]: "В ревью",
    [UserStateChangeReason.ResetReviewByScamMessages]: "В ревью: Мошеннические сообщения",
    [UserStateChangeReason.ResetReviewByTooManyLikes]: "В ревью: Многочисленные лайки",
    [UserStateChangeReason.ResetReviewByNoFacePhoto]: "В ревью: Фото без лица",
    [UserStateChangeReason.ResetReviewByAbuse]: "В ревью: Триггерное слово",
    [UserStateChangeReason.ResetReviewByMultipleVerifications]: "В ревью: Множественные верификации",
    [UserStateChangeReason.ResetReviewByMinorDetected]: "В ревью: Несовершеннолетний",
    [UserStateChangeReason.ResetReviewByDuplicateFacePhoto]: "В ревью: Дубликаты лиц",
    [UserStateChangeReason.ResetReviewByMultiLogin]: "В ревью: Множественные аккаунты с одного устройства",
    [UserStateChangeReason.PromoteSupportToSuperAdmin]: "Повышение поддержки до суперадмина",
    [UserStateChangeReason.DemoteSuperAdminToSupport]: "Понижение суперадмина до поддержки",
    [UserStateChangeReason.ForcedVerificationByAbuse]: "Принудительная верификация: Триггерное слово",
    [UserStateChangeReason.SuccessfulVerification]: "Успешная верификация",
    [UserStateChangeReason.ForcedVerificationByDuplicateFacePhoto]: "Принудительная верификация: Дубликаты лиц",
    [UserStateChangeReason.SuspiciousByDuplicateFacePhoto]: "Подозрение: Дубликаты лиц",
    [UserStateChangeReason.ResetVerificationByPhotoDeleted]: "Сброс верификации: После удаления фото",
    [UserStateChangeReason.ResetVerificationBySupport]: "Сброс верификации: Решение поддержки",
    [UserStateChangeReason.ResetReviewBySensitivePhoto]: "В ревью: Sensitive фото",
    [UserStateChangeReason.ResetReviewByDifferentFace]: "В ревью: Добавлено новое лицо в фото",
    [UserStateChangeReason.ResetReviewByQrCode]: "В ревью: QR-код на фото",
    [UserStateChangeReason.ResetReviewByCelebrity]: "В ревью: Знаменитость на фото",
    [UserStateChangeReason.SuspiciousDevice]: "Подозрение: Устройство",
    [UserStateChangeReason.OldAppVersion]: "Старая версия приложения",
    [UserStateChangeReason.IpAddressReuseAndPhotoDuplicates]: "Повторное использование IP и дубли фото",
    [UserStateChangeReason.IpAddressReuseAndSuspiciousTag]: "Повторное использование IP и подозрительный тег",
    [UserStateChangeReason.IpAddressReuseAndAdminCheckAboutOrPhoto]: "Повторное использование IP и Триггерное слово",
    [UserStateChangeReason.BlockedCountryInRegionCode]: "Бан: Заблокированная страна в локали симки",
    [UserStateChangeReason.DuplicateHashPhoto]: "Дублирующееся хеш-фото",
    [UserStateChangeReason.SuspiciousOldDevice]: "Подозрение: Старое устройство",
    [UserStateChangeReason.SuspiciousAppCheckDevice]: "Подозрение: Возможно, виртуальное устройство",
    [UserStateChangeReason.DetectAbuseInGreeting]: "Триггерное слово: Сообщение",
    [UserStateChangeReason.ShadowDelete]: "Теневое удаление",
    [UserStateChangeReason.BannedByDeviceRegionCode]: "Бан: Заблокированная страна в локали телефона",
    [UserStateChangeReason.CreateTestUser]: "Конверт в тестогово пользователя",
    [UserStateChangeReason.PostponeBySupport]: "Отложено на потом",
    [UserStateChangeReason.CreateBlackListUser]: "Создание пользователя в черном списке",
    [UserStateChangeReason.BannedByBlackListHash]: "Теневой бан: Фото из черного списка",
    [UserStateChangeReason.ShadowBanByAbuse]: "Теневой бан: Abuse слово",
};

export const UserStateChangeReasonEmojis: Record<UserStateChangeReason, string> = {
    [UserStateChangeReason.Unknown]: "❓",
    [UserStateChangeReason.Registration]: "⚪",
    [UserStateChangeReason.ReadyForReview]: "⚪",
    [UserStateChangeReason.Pause]: "🟢️",
    [UserStateChangeReason.ResetPause]: "🟢",
    [UserStateChangeReason.DetectAbuseInAbout]: "🟡",
    [UserStateChangeReason.DetectAbuseInAboutQuestion]: "🟡",
    [UserStateChangeReason.DetectAbuseInCustomIcebreaker]: "🟡",
    [UserStateChangeReason.BanByBlockedCountry]: "🔴",
    [UserStateChangeReason.BanByComplaints]: "🔴",
    [UserStateChangeReason.BanByExpiredTemporaryUnban]: "🔴",
    [UserStateChangeReason.BanByLinkToBannedUser]: "🔴",
    [UserStateChangeReason.BanByMultiLogin]: "🔴",
    [UserStateChangeReason.BanByScamPremiumTransaction]: "🔴",
    [UserStateChangeReason.BanBySupport]: "️🔴",
    [UserStateChangeReason.UnbanBySupport]: "🟢",
    [UserStateChangeReason.TemporaryUnbanBySupport]: "🟢",
    [UserStateChangeReason.ForcedVerificationBySupport]: "🟡",
    [UserStateChangeReason.ForcedVerificationByScamMessages]: "🟡",
    [UserStateChangeReason.ForcedVerificationByScreenshots]: "🟡",
    [UserStateChangeReason.ForcedVerificationByMatches]: "🟡",
    [UserStateChangeReason.SuccessfulForcedVerification]: "🟢",
    [UserStateChangeReason.SuspiciousWasReviewed]: "🟢️",
    [UserStateChangeReason.SuspiciousByScamMessages]: "🟡",
    [UserStateChangeReason.SuspiciousByTooManyLikes]: "🟡️",
    [UserStateChangeReason.SuspiciousByDuplicateVerifications]: "🟡",
    [UserStateChangeReason.AutomaticBanByDuplicateVerifications]: "🔴",
    [UserStateChangeReason.SuspiciousByIpAddressesReuse]: "🟡",
    [UserStateChangeReason.SuspiciousByNickname]: "🟡",
    [UserStateChangeReason.ArchivedByInactivity]: "⚪",
    [UserStateChangeReason.RestoreFromArchivedByLogin]: "⚪",
    [UserStateChangeReason.CreateSupportUser]: "️⚪‍",
    [UserStateChangeReason.BlockSupportUser]: "‍🔴",
    [UserStateChangeReason.ForcedVerificationByCelebrity]: "🟡",
    [UserStateChangeReason.ForcedVerificationByDifferentFace]: "🟡‍",
    [UserStateChangeReason.SuspiciousByQrCode]: "🟡",
    [UserStateChangeReason.DetectAbuseInPhoto]: "🟡",
    [UserStateChangeReason.DetectAbuseInChat]: "🟡",
    [UserStateChangeReason.DetectAbuseInName]: "🟡",
    [UserStateChangeReason.SuspiciousByComplaints]: "🟡",
    [UserStateChangeReason.WasReviewed]: "🟢️",
    [UserStateChangeReason.AutomaticReviewByFullProfile]: "🟢️",
    [UserStateChangeReason.AutomaticReviewBySensitivePhotoDeleted]: "🟢️",
    [UserStateChangeReason.AutomaticReviewByNormalPhotoAfterNoFace]: "🟢️",
    [UserStateChangeReason.ResetReview]: "⚪‍",
    [UserStateChangeReason.ResetReviewByScamMessages]: "🟡",
    [UserStateChangeReason.ResetReviewByTooManyLikes]: "🟡",
    [UserStateChangeReason.ResetReviewByNoFacePhoto]: "🟡",
    [UserStateChangeReason.ResetReviewByAbuse]: "🟡",
    [UserStateChangeReason.ResetReviewByMultipleVerifications]: "🟡",
    [UserStateChangeReason.ResetReviewByMinorDetected]: "🟡",
    [UserStateChangeReason.ResetReviewByDuplicateFacePhoto]: "🟡",
    [UserStateChangeReason.ResetReviewByMultiLogin]: "🟡",
    [UserStateChangeReason.PromoteSupportToSuperAdmin]: "⚪‍",
    [UserStateChangeReason.DemoteSuperAdminToSupport]: "⚪‍",
    [UserStateChangeReason.ForcedVerificationByAbuse]: "🟡",
    [UserStateChangeReason.SuccessfulVerification]: "🟢️",
    [UserStateChangeReason.ForcedVerificationByDuplicateFacePhoto]: "🟡",
    [UserStateChangeReason.SuspiciousByDuplicateFacePhoto]: "🟡",
    [UserStateChangeReason.ResetVerificationByPhotoDeleted]: "🟡",
    [UserStateChangeReason.ResetVerificationBySupport]: "⚪‍",
    [UserStateChangeReason.ResetReviewBySensitivePhoto]: "🟡",
    [UserStateChangeReason.ResetReviewByDifferentFace]: "🟡",
    [UserStateChangeReason.ResetReviewByQrCode]: "🟡",
    [UserStateChangeReason.ResetReviewByCelebrity]: "🟡",
    [UserStateChangeReason.SuspiciousDevice]: "🟡",
    [UserStateChangeReason.OldAppVersion]: "🟡",
    [UserStateChangeReason.IpAddressReuseAndPhotoDuplicates]: "🟡",
    [UserStateChangeReason.IpAddressReuseAndSuspiciousTag]: "🟡",
    [UserStateChangeReason.IpAddressReuseAndAdminCheckAboutOrPhoto]: "🟡",
    [UserStateChangeReason.BlockedCountryInRegionCode]: "‍🔴",
    [UserStateChangeReason.DuplicateHashPhoto]: "🟡",
    [UserStateChangeReason.SuspiciousOldDevice]: "🟡",
    [UserStateChangeReason.SuspiciousAppCheckDevice]: "🟡",
    [UserStateChangeReason.DetectAbuseInGreeting]: "🟡",
    [UserStateChangeReason.ShadowDelete]: "‍🔴",
    [UserStateChangeReason.BannedByDeviceRegionCode]: "‍🔴",
    [UserStateChangeReason.CreateTestUser]: "⚪‍",
    [UserStateChangeReason.PostponeBySupport]: "⚪‍",
    [UserStateChangeReason.CreateBlackListUser]: "⚫",
    [UserStateChangeReason.BannedByBlackListHash]: "⚫",
    [UserStateChangeReason.ShadowBanByAbuse]: "⚫",
};


export const toStatusChangesReasonString = (v: UserStateChangeReason, withEmoji: boolean = true) => UserStateChangeReasonDesc[v] ? `${withEmoji ? UserStateChangeReasonEmojis[v] : ''} ${UserStateChangeReasonDesc[v]}` : v

